var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pot-1-terminal"},[_c('pot-1-terminal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }